// extracted by mini-css-extract-plugin
export default {"modal":"AddInTurnOffAutosave_modal__dRIIi","body":"AddInTurnOffAutosave_body__1xrP-"};